<template>
  <div class="voc">
    <div class="voc__title">
      평범한 후기 몇 개가 아닙니다<br />
      진정성 있는 후기 <strong>2,384</strong>개는 만들 수 없습니다
    </div>
    <div class="voc__categories">
      <ul class="blog-categories">
        <li v-for="category in categories">
          <button
            :class="{ active: category === selectedCategory }"
            @click="selectCategory(category)"
          >
            {{ category }}
          </button>
        </li>
      </ul>
    </div>
    <div ref="vocListWrapper" class="voc__list-wrapper">
      <client-only>
        <div
          v-masonry="containerId"
          :gutter="24"
          class="voc__list"
          transition-duration="0s"
          item-selector=".voc-card"
        >
          <voc-card
            v-masonry-tile
            v-for="(review, index) in renderReviews"
            :key="index"
            :data="review"
            company-logo=""
            class="voc__item"
          />
        </div>
      </client-only>
    </div>
    <div v-if="displayBtn" class="voc__btn">
      <!-- todo -->
      <div @click="pagination" class="btn btn--primary-2">
        고객 목소리 더보기
      </div>
    </div>
  </div>
</template>

<script>
import CUSTOMER_REVIEWS from '~/customer-reviews.json'
import VocCard from '~/components/customer-review/voc-card'

export default {
  components: {
    VocCard
  },
  data: () => ({
    currentPage: 0,
    displayBtn: true,
    containerId: 'masonry-grid-1',
    renderReviews: [],
    selectedCategory: '전체 보기',
    categories: [
      '전체 보기',
      '신뢰 (정확한 업무처리)',
      '고객소통 (친절)',
      '시스템',
      '절세/지원금 (전문성, 선제적)',
      '부가서비스'
    ]
  }),
  computed: {
    filteredRenderReviews() {
      const sortedCustomerReviews = CUSTOMER_REVIEWS.sort((a, b) => {
        if (a.pros.length > b.pros.length) {
          return -1
        }
        if (a.pros.length < b.pros.length) {
          return 1
        }

        return 0
      })

      if (this.selectedCategory === '전체 보기') return sortedCustomerReviews

      return sortedCustomerReviews.filter((review) => {
        return review.type === this.selectedCategory
      })
    }
  },
  watch: {
    filteredRenderReviews: {
      handler() {
        this.init()
        this.pagination()
        this.redrawVueMasonry()
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.currentPage = 0
      this.renderReviews = []
    },
    redrawVueMasonry() {
      this.$nextTick(() => {
        this.$redrawVueMasonry('masonry-grid-1')
      })
    },
    pagination() {
      const nextPage = this.currentPage + 100
      const customerReview = this.filteredRenderReviews.slice(
        this.currentPage,
        nextPage
      )

      this.currentPage = nextPage
      this.renderReviews.push(...customerReview)

      const nextCustomerReview = this.filteredRenderReviews.slice(
        this.currentPage,
        this.currentPage + 100
      )

      this.displayBtn = !!nextCustomerReview.length
      this.redrawVueMasonry()
    },
    selectCategory(category) {
      this.selectedCategory = category
    }
  }
}
</script>

<style lang="scss">
.voc {
  padding: 104px 1.5rem;
  overflow: hidden;

  &__title {
    margin-bottom: 1rem;
    font-size: 26px;
    line-height: normal;
    text-align: center;
    color: #323438;
    word-break: keep-all;

    @include av-mq(lap-and-up) {
      font-size: 32px;
    }
  }

  &__categories {
    margin-bottom: 3rem;
  }

  &__list-wrapper {
    position: relative;
    margin: -32px -32px 0;
    padding: 32px;
    height: 100%;
  }

  &__item {
    margin-bottom: 1.5rem;
    transition: transform 0.2s;

    &:last-of-type {
      margin-bottom: 3rem;
    }

    @include av-mq(handheld-and-up) {
      width: calc(50% - 0.75rem);
    }
  }

  &__btn {
    text-align: center;
  }
}
</style>
